import { render, staticRenderFns } from "./qpe_histogram.vue?vue&type=template&id=fcd849c4&"
import script from "./qpe_histogram.vue?vue&type=script&lang=js&"
export * from "./qpe_histogram.vue?vue&type=script&lang=js&"
import style0 from "./qpe_histogram.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\1603014\\develop\\qplus\\qpeplus\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('fcd849c4', component.options)
    } else {
      api.reload('fcd849c4', component.options)
    }
    module.hot.accept("./qpe_histogram.vue?vue&type=template&id=fcd849c4&", function () {
      api.rerender('fcd849c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/chart/qpe_histogram.vue"
export default component.exports